module.exports = __webpack_public_path__ + "img/arrow-right-grey.04d4209c.svg";